import { useState, useEffect } from 'react';
import { promoBannerAPI, IMAGE_BASE } from '../../services/api';

export default function PromoBannerAdmin() {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({
        title: '', description: '', buttonText: '', buttonLink: '',
        sortOrder: 0, isActive: true
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formBusy, setFormBusy] = useState(false);

    const fetchBanners = async () => {
        setLoading(true);
        try {
            const res = await promoBannerAPI.getAll();
            setBanners(res.data || []);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { fetchBanners(); }, []);

    const openCreate = () => {
        setEditItem(null);
        setForm({ title: '', description: '', buttonText: '', buttonLink: '', sortOrder: 0, isActive: true });
        setImageFile(null);
        setImagePreview(null);
        setShowModal(true);
    };

    const openEdit = (item) => {
        setEditItem(item);
        setForm({
            title: item.title || '', description: item.description || '',
            buttonText: item.buttonText || '', buttonLink: item.buttonLink || '',
            sortOrder: item.sortOrder || 0, isActive: item.isActive
        });
        setImageFile(null);
        setImagePreview(item.image ? IMAGE_BASE + item.image : null);
        setShowModal(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormBusy(true);
        try {
            const fd = new FormData();
            Object.entries(form).forEach(([k, v]) => fd.append(k, v));
            if (imageFile) fd.append('image', imageFile);

            if (editItem) {
                await promoBannerAPI.update(editItem.id, fd);
            } else {
                await promoBannerAPI.create(fd);
            }
            setShowModal(false);
            fetchBanners();
        } catch (err) {
            alert(err.response?.data?.error || 'Hata oluştu');
        }
        setFormBusy(false);
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu banner\'i silmek istediğinize emin misiniz?')) return;
        try {
            await promoBannerAPI.delete(id);
            fetchBanners();
        } catch (err) {
            alert(err.response?.data?.error || 'Silinemedi');
        }
    };

    return (
        <div>
            <div className="admin-header">
                <h1>Banner Yönetimi</h1>
                <button className="btn btn-primary" onClick={openCreate}>+ Yeni Banner</button>
            </div>

            {loading ? <div className="loading"><div className="spinner"></div></div> : (
                <div className="data-table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Görsel</th>
                                <th>Başlık</th>
                                <th>Buton</th>
                                <th>Sıra</th>
                                <th>Durum</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {banners.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        {item.image ? (
                                            <img src={IMAGE_BASE + item.image} alt={item.title || 'Banner'} style={{ width: 120, height: 50, objectFit: 'cover', borderRadius: 6 }} />
                                        ) : <span style={{ color: 'var(--text-muted)' }}>-</span>}
                                    </td>
                                    <td style={{ fontWeight: 600 }}>{item.title || '-'}</td>
                                    <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{item.buttonText || '-'}</td>
                                    <td>{item.sortOrder}</td>
                                    <td>
                                        <span className={`stock-badge ${item.isActive ? 'stock-in' : 'stock-out'}`}>
                                            {item.isActive ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button className="btn-icon" onClick={() => openEdit(item)}>&#9998;&#65039;</button>
                                            <button className="btn-icon" onClick={() => handleDelete(item.id)} style={{ color: 'var(--danger)' }}>&#128465;&#65039;</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {banners.length === 0 && (
                                <tr><td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Henüz banner eklenmemiş</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowModal(false)}>
                    <div className="modal" style={{ maxWidth: 600 }}>
                        <div className="modal-header">
                            <h2>{editItem ? 'Banner Düzenle' : 'Yeni Banner'}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="form-group">
                                    <label>Görsel *</label>
                                    <input type="file" accept="image/*" onChange={handleImageChange} className="form-control" />
                                    {imagePreview && (
                                        <img src={imagePreview} alt="Preview" style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 8, marginTop: 8 }} />
                                    )}
                                </div>
                                <div className="form-group">
                                    <label>Başlık</label>
                                    <input className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Opsiyonel - görselin üzerinde görünür" />
                                </div>
                                <div className="form-group">
                                    <label>Açıklama</label>
                                    <textarea className="form-control" rows={3} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Opsiyonel" />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Buton Metin</label>
                                        <input className="form-control" value={form.buttonText} onChange={e => setForm({ ...form, buttonText: e.target.value })} placeholder="ör: Hemen Al" />
                                    </div>
                                    <div className="form-group">
                                        <label>Buton Link</label>
                                        <input className="form-control" value={form.buttonLink} onChange={e => setForm({ ...form, buttonLink: e.target.value })} placeholder="ör: /ürünler" />
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Sıra</label>
                                        <input type="number" className="form-control" value={form.sortOrder} onChange={e => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })} />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} /> Aktif
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn btn-primary" disabled={formBusy}>
                                    {formBusy ? 'Kaydediliyor...' : (editItem ? 'Güncelle' : 'Ekle')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
